/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 17.5 2 12 6.5 2 12 2Zm4.656 5.333a.9.9 0 0 0-1.273.001l-3.1 3.105-.064.052a.4.4 0 0 1-.503-.052L8.617 7.334a.9.9 0 0 0-1.273 0l-.08.091a.9.9 0 0 0 .08 1.18l3.102 3.11a.4.4 0 0 1 0 .565l-3.103 3.109a.9.9 0 1 0 1.274 1.271l3.1-3.106a.4.4 0 0 1 .565 0l3.1 3.106a.9.9 0 0 0 1.274.001l.08-.092a.9.9 0 0 0-.08-1.18l-3.103-3.11a.4.4 0 0 1 0-.565l3.104-3.108a.9.9 0 0 0-.001-1.273Z"
})), "0 0 24 24", "CloseCircle");